// Material 3 palettes for the supported color schemes.
// GENERATED by tools/generatePalette.mjs from seed #0050A3.
// Re-run that script (with a new seed) instead of hand-editing this file.
// Light accent/error roles are pinned to the ODL UI style guide by the
// generator; the dark scheme is fully seed-derived.
//
// Each palette is *data only* — cssTokens.js consumes these to build the
// :root / [data-scheme] CSS-var blocks, and index.js builds the MUI palette.
// Components should never import from here directly; reach for the CSS vars
// or the MUI theme.

export const LIGHT_PALETTE = {
  primary: '#0050A3',
  primaryRgb: '0, 80, 163',
  onPrimary: '#FFFFFF',
  primaryContainer: '#E7F0FF',
  onPrimaryContainer: '#033668',
  secondary: '#565E71',
  onSecondary: '#FFFFFF',
  secondaryContainer: '#DAE2F9',
  onSecondaryContainer: '#131C2B',
  tertiary: '#705574',
  onTertiary: '#FFFFFF',
  tertiaryContainer: '#FAD8FD',
  onTertiaryContainer: '#28132E',
  error: '#DC2626',
  onError: '#FFFFFF',
  errorContainer: '#FEF2F2',
  onErrorContainer: '#B91C1C',
  background: '#FDFBFF',
  onBackground: '#1A1B1F',
  surface: '#FDFBFF',
  onSurface: '#1A1B1F',
  surfaceVariant: '#E0E2EC',
  onSurfaceVariant: '#44474E',
  outline: '#74777F',
  outlineVariant: '#C4C6D0',
  shadow: '#000000',
  scrim: '#000000',
  inverseSurface: '#2F3033',
  inverseOnSurface: '#F2F0F4',
  inversePrimary: '#ABC7FF',
  surfaceDim: '#DBD9DD',
  surfaceBright: '#FAF9FD',
  surfaceContainerLowest: '#FFFFFF',
  surfaceContainerLow: '#F4F3F7',
  surfaceContainer: '#EFEDF1',
  surfaceContainerHigh: '#E9E7EC',
  surfaceContainerHighest: '#E3E2E6',
};

export const DARK_PALETTE = {
  primary: '#ABC7FF',
  primaryRgb: '171, 199, 255',
  onPrimary: '#002F65',
  primaryContainer: '#00458E',
  onPrimaryContainer: '#D7E3FF',
  secondary: '#BEC6DC',
  onSecondary: '#283141',
  secondaryContainer: '#3E4759',
  onSecondaryContainer: '#DAE2F9',
  tertiary: '#DDBCE0',
  onTertiary: '#3F2844',
  tertiaryContainer: '#573E5C',
  onTertiaryContainer: '#FAD8FD',
  error: '#FFB4AB',
  onError: '#690005',
  errorContainer: '#93000A',
  onErrorContainer: '#FFB4AB',
  background: '#1A1B1F',
  onBackground: '#E3E2E6',
  surface: '#1A1B1F',
  onSurface: '#E3E2E6',
  surfaceVariant: '#44474E',
  onSurfaceVariant: '#C4C6D0',
  outline: '#8E9099',
  outlineVariant: '#44474E',
  shadow: '#000000',
  scrim: '#000000',
  inverseSurface: '#E3E2E6',
  inverseOnSurface: '#2F3033',
  inversePrimary: '#1E5DB0',
  surfaceDim: '#121316',
  surfaceBright: '#38393C',
  surfaceContainerLowest: '#0D0E11',
  surfaceContainerLow: '#1A1B1F',
  surfaceContainer: '#1F1F23',
  surfaceContainerHigh: '#292A2D',
  surfaceContainerHighest: '#343538',
};

export const PALETTES = {
  light: LIGHT_PALETTE,
  dark: DARK_PALETTE,
};

export const getPalette = scheme => PALETTES[scheme] || LIGHT_PALETTE;
